import React, { useEffect } from 'react';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const LanguageSwitcher: React.FC = () => {
  // Use untyped translation hook to bypass TypeScript errors
  const { t, i18n } = useUntypedTranslation();
  
  // Normalize the language code to match our supported languages
  const normalizeLanguage = (lang: string): string => {
    // If language includes a region (e.g., 'en-US'), extract the main language part
    const mainLang = lang.split('-')[0];
    // Check if the main language is supported, otherwise default to 'de'
    return ['en', 'de'].includes(mainLang) ? mainLang : 'de';
  };
  
  // Get the current normalized language
  const currentLang = normalizeLanguage(i18n.language);
  
  // Effect to ensure language is normalized on mount
  useEffect(() => {
    const normalizedLang = normalizeLanguage(i18n.language);
    if (normalizedLang !== i18n.language) {
      i18n.changeLanguage(normalizedLang);
    }
  }, [i18n]);
  
  const changeLanguage = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newLang = event.target.value as string;
    i18n.changeLanguage(newLang);
  };
  
  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="language-select-label">{t('language.select')}</InputLabel>
      <Select
        labelId="language-select-label"
        id="language-select"
        value={currentLang}
        onChange={changeLanguage as any}
        label={t('language.select')}
      >
        <MenuItem value="en">{t('language.en')}</MenuItem>
        <MenuItem value="de">{t('language.de')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher; 